import React from 'react';
import PropTypes from 'prop-types';
import useTags from '../../hooks/useTags';
import TagRelationPicker from '../tags/TagRelationPicker';

// Global is a structural fact about every asset (assigned automatically, never editable
// here per spec) — it's excluded from both the chip list and the add-search options.
// Auto and manual tags are shown together with their edit controls always present, rather
// than a separate read-only view plus a separate editor for the same data.
export default function AssetTagsSection({ manualTagIds, autoTagIds, onUpdate }) {
  const { tags } = useTags();
  const selectableTags = tags.filter((t) => !t.is_system);

  const allTagIds = [...new Set([...manualTagIds, ...autoTagIds])];

  const handleAdd = (tagId) => {
    onUpdate?.({ tag_ids: [...manualTagIds, tagId] });
  };

  const handleRemove = (tagId) => {
    onUpdate?.({ tag_ids: manualTagIds.filter((id) => id !== tagId) });
  };

  return (
    <div className="mt-3">
      <div className="small text-muted mb-1">Tags</div>
      <TagRelationPicker
        tags={selectableTags}
        selectedIds={allTagIds}
        autoTagIds={autoTagIds}
        onAdd={handleAdd}
        onRemove={handleRemove}
        placeholder="Add a tag…"
        emptyHint="No tags yet"
      />
    </div>
  );
}

AssetTagsSection.propTypes = {
  manualTagIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  autoTagIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  onUpdate: PropTypes.func,
};

AssetTagsSection.defaultProps = {
  manualTagIds: [],
  autoTagIds: [],
  onUpdate: undefined,
};
